import React, { Fragment, memo, ReactElement } from "react";

import "./bottom-menu.css";
import { useBottomMenu } from "../../hooks/useBottomMenu";

/** Bottom Menu that will show the content of the BottomMenuContext (stack and confirmation bar) */
export const BottomMenu = memo(() => {
	const { stack, loadingPath } = useBottomMenu();
	const isLoading = !!loadingPath;

	const itemsToShow = stack
		.slice(0) // Because reverse does update the array
		.reverse()
		.map((item) => <Fragment key={item.id}>{item.menuItem as ReactElement}</Fragment>);

	return (
		<div className={`bottom-menu ${isLoading ? "bottom-menu--is-loading" : ""}`}>
			{itemsToShow}
		</div>
	);
});
BottomMenu.displayName = "BottomMenu";
